import { render, staticRenderFns } from "./CreateFeedContainerTags.vue?vue&type=template&id=bfbf77d0&"
import script from "./CreateFeedContainerTags.vue?vue&type=script&lang=ts&"
export * from "./CreateFeedContainerTags.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports